/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// COMPONENTS
import MUIDataTable from 'mui-datatables';
// ICONS
// CUSTOM COMPONENTS
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import CustomBlock from '../../../../components/CustomBlock';
import ContentHeader from '../../../../components/ContentHeader';
import ModalBlock from '../../../../components/ModalBlock';
import FormBlock from '../../../../components/FormBlock';
import Button from '../../../../components/Button';
import InputBlock from '../../../../components/InputBlock';
import OverLay from '../../../../components/Overlay';
import CheckboxBlock from '../../../../components/CheckboxBlock';
// REDUX
import * as alert from '../../../../redux/alertToastRedux';
import * as confirmModal from '../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as helper from '../../../../helpers/helper';
import * as licensorService from '../../../../services/management/licensorService';

const LicensorListingPage = (props) => {
  const { showAlert, showConfirmModal, hideConfirmModal, auth } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [licensors, setlicensors] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const initialLicensorModel = {
    id: 0,
    name: '',
    isActive: true
  };
  const [licensor, setLicensor] = useState(initialLicensorModel);

  useEffect(() => {
    getLicensors();
  }, []);

  const formik = useFormik({
    initialValues: licensor,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      id: Yup.number(),
      name: Yup.string().required().max(500),
      isActive: Yup.bool().nullable(),
    }),
    onSubmit: (values) => {
      setIsLoading(true);
      if (values.id === 0) {
        createLicensor(values);
      } else {
        updateLicensor(values);
      }
    },
  });

  const getLicensors = () => {
    setIsLoading(true);
    licensorService.getAllLicensors('').then((res) => {
      setlicensors(res);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const getLicensor = (id) => {
    setIsLoading(true);
    licensorService.getLicensorById(id).then((res) => {
      setLicensor(res);
      setIsModalOpen(true);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const deleteLicensor = (id) => {
    setIsLoading(true);
    hideConfirmModal();
    licensorService.deleteLicensor(id).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getLicensors();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const createLicensor = (model) => {
    licensorService.createLicensor(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getLicensors();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleModalClose();
      setIsLoading(false);
    });
  };

  const updateLicensor = (model) => {
    licensorService.updateLicensor(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      getLicensors();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      handleModalClose();
      setIsLoading(false);
    });
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setTimeout(() => {
      setLicensor(initialLicensorModel);
      formik.resetForm();
    }, 250);
  };

  // const iconSize = 22;
  // const iconColor = 'white--clr';

  const columnOptions = {
    filter: true,
    sort: true,
    print: false,
    download: true
  };

  const options = {
    selectableRows: 'none',
    download: true,
    print: false,

  };

  const columns = [
    {
      name: 'id',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        print: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          const { id } = licensors[dataIndex];

          return (
            <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
              <Button
                text="View"
                className="primary--bg ml-0"
                size="xxs"
                to={`/licensor/${id}`}
              />
              {
                auth.accessLevel >= 50 && (
                  <>
                    <Button
                      text="Edit"
                      className="secondary--bg ml-3"
                      size="xxs"
                      onClick={() => {
                        getLicensor(id);
                      }}
                    />
                    <Button
                      text="Delete"
                      className="danger--bg"
                      size="xxs"
                      onClick={() => {
                        showConfirmModal({
                          title: 'Delete Licensor',
                          text: 'Are you sure you want to delete this licensor?',
                          rightBtnText: 'Confirm',
                          btnAction: () => {
                            deleteLicensor(id);
                          }
                        });
                      }}
                    />
                  </>
                )
              }
            </CustomBlock>
          );
        }
      }
    },
    {
      name: 'name',
      label: 'Name',
      options: columnOptions,
    },
    {
      name: 'connectionTypes',
      label: 'Connection Types',
      options: {
        ...columnOptions,
        customBodyRenderLite: (dataIndex) => (<p>{licensors[dataIndex].connectionTypes.map((x) => x.name).join(', ')}</p>)

      },
    },
    {
      name: 'isActive',
      label: 'Is Active?',
      options: {
        ...columnOptions,
        customBodyRenderLite: (dataIndex) => (<p>{licensors[dataIndex].isActive ? 'Yes' : 'No'}</p>)
      },
    },
  ];

  return (
    <>
      {isLoading && <OverLay hasLoader />}
      <CustomBlock className="content-container--padded">
        <Section isFullWidth>
          <ContentBlock>
            <CustomBlock className="content-container--card-style--with-shadow">
              <ContentHeader
                title="Licensors"
                headerSize="lg"
                primaryButtonText={auth.accessLevel > 40 ? 'New Licensor' : ''}
                primaryButtonOnClick={() => setIsModalOpen(true)}
              />

              <CustomBlock>
                <MUIDataTable
                  data={licensors}
                  columns={columns}
                  options={options}
                />
              </CustomBlock>
            </CustomBlock>
          </ContentBlock>
        </Section>
      </CustomBlock>

      <ModalBlock
        hasCloseAction
        centered
        isVisible={isModalOpen}
        size="md"
        contentHeader={licensor.id === 0 ? 'Add Licensor' : 'Edit Licensor'}
        primaryModalActionText={licensor.id === 0 ? 'Create' : 'Save Changes'}
        primaryModalActionColor="primary--bg"
        primaryModalActionOnClick={formik.handleSubmit}
        secondaryModalActionText="Cancel"
        secondaryModalActionColor="danger--bg"
        onHide={handleModalClose}
      >
        <FormBlock onSubmit={formik.handleSubmit}>
          <Section hasNoContainer>
            <ContentBlock>
              <InputBlock
                label="Name"
                isRequired
                errorMessage={formik.errors.name}
                inputState={`${helper.getInputClasses(formik, 'name')}`}
                {...formik.getFieldProps('name')}
              />
            </ContentBlock>

            <ContentBlock>
              <CheckboxBlock
                label="Is active?"
                id="isActive"
                {...formik.getFieldProps('isActive')}
                isChecked={formik.values.isActive}
              />
            </ContentBlock>
          </Section>
        </FormBlock>
      </ModalBlock>
    </>
  );
};

const mapStateFromProps = (state) => ({ auth: state.auth });

export default connect(
  mapStateFromProps,
  {
    ...alert.actions,
    ...confirmModal.actions
  }
)(LicensorListingPage);